import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"my-7 text-center"},[_c(VBtn,{attrs:{"outlined":"","icon":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_c(VIcon,[_vm._v("mdi-arrow-left")])],1),_c('h1',[_vm._v("Page Not Found")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }